import React from "react";
import { Btn, FormInput } from "./utils";
import { CloseSquare } from "iconsax-react";


const EditPopup = ({ isEdit, editBtn, setIsEdit, estate, changeInput, err, loading }) => {

  return (
    <div
      className="edit_est"
      style={isEdit ? { display: "flex" } : { display: "none" }}
    >
      <div className="close_ic">
        <CloseSquare
          size="32"
          color="#000000"
          onClick={() => {
            setIsEdit(!isEdit);
          }}
          style={{ cursor: "pointer" }}
        />
      </div>
      <div className="edit_est_head">
        <h3>Edit Estate</h3>
        <p>Change estate name</p>
      </div>
      <div className="edit_est_inp">
        <p>Estate Name</p>
        <FormInput err={err} placeholder={estate} labelBg={"transparent"} changeInput={changeInput} />
      </div>
      <div className="edit_est_btn">
        <Btn
          btnText={"Cancel"}
          btnClass={"home-btn_trans-s"}
          btnClick={() => {
            setIsEdit(!isEdit);
          }}
        />
        <Btn
          btnText={"Save Estate"}
          btnClass={"home-btn_s"}
          btnClick={editBtn}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default EditPopup;
